import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var format_list_bullets_rtl_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4 8.8h8.9V7.2H4v1.6zm0 7h8.9v-1.5H4v1.5zM18 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" }) });
export {
  format_list_bullets_rtl_default as default
};
//# sourceMappingURL=format-list-bullets-rtl.js.map
